/**
 * Service to handle API calls for languages.
 * Created on 01-01-2025
 */
import axios from "../services/axiosService.js";
import CommonService from "../services/commonService.js";

//  Mock Data imports
import languageData from "../assets/data/language.json";
import msLanguages from "../assets/data/msLanguages.json";

class LanguageService {
  commonService = new CommonService();
  constructor() {
    this.apiPointer = process.env.REACT_APP_WEB_API_POINTER;
    this.apiFolder = process.env.REACT_APP_WEB_API_FOLDER;

    //  API url methods
    this.apiUrl = {
      getLanguageFinesse: "/getLanguageFinesse?project_UUID=<vProjectId>",
      getLanguages: "/Transformation/GetAllMSLanguages",
      setDiscardOrReplaceaLanguage: "/Prompt/InsertDiscardPPTResponse",
      setTransFormLanguage: "/Transformation/LanguageImprovement",
    };

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      "getLanguageFinesse",
      // 'getLanguages',
      // "setDiscardOrReplaceaLanguage",
      // 'setTransFormLanguage'
    ];
  }

  /**
   * Function to get Language Finesse
   * @param {*} projectId. userId
   * @returns
   */
  getLanguageFinesse = async (projectId, userId) => {
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("getLanguageFinesse")
      ) {
        return Promise.resolve([]);
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl =
          vApiEndpoint +
          this.apiFolder +
          this.apiUrl.getLanguageFinesse.replace("<vProjectId>", projectId);
        return await axios
          .get(vUrl, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Accept: "application/json",
            },
          })
          .then((data) => {
            const response = data?.data;
            return response;
          });
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "LanguageService",
        "getLanguageFinesse"
      );
    }
  };

  /**
   * Function to get MicroSoft languages
   * @param {*}
   * @returns
   */
  getLanguages = async () => {
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("getLanguages")
      ) {
        return Promise.resolve(msLanguages);
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl = vApiEndpoint + this.apiFolder + this.apiUrl.getLanguages;
        return await axios
          .get(vUrl, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Accept: "application/json",
            },
          })
          .then((data) => {
            const response = data?.data;
            return response;
          });
      }
    } catch (error) {
      this.commonService.logException(error, "LanguageService", "getLanguages");
    }
  };

  /**
   * Function to replace or discard languages
   * @param {*} vResponse
   * @param {*} vFlag
   * @returns
   */
  setDiscardOrReplaceaLanguage = async (vResponse, vFlag) => {
    const vData = {
      responseId: vResponse.responseId,
      insertDiscardFlag: vFlag,
    };
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("setDiscardOrReplaceaLanguage")
      ) {
        return Promise.resolve("Langauge updated successfully");
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl =
          vApiEndpoint +
          this.apiFolder +
          this.apiUrl.setDiscardOrReplaceaLanguage;
        return await axios.post(vUrl, vData).then((response) => {
          const res = response;
          return res;
        });
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "LanguageService",
        "setDiscardOrReplaceaLanguage"
      );
    }
  };

  setTransFormLanguage = async (transformLanguage) => {
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("setTransFormLanguage")
      ) {
        return Promise.resolve(languageData[0]);
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl =
          vApiEndpoint + this.apiFolder + this.apiUrl.setTransFormLanguage;
        return await axios.post(vUrl, transformLanguage).then((response) => {
          const res = response?.data;
          return res;
        });
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "LanguageService",
        "setTransFormLanguage"
      );
    }
  };
}

export default LanguageService;
